import { render, staticRenderFns } from "./authorizationManagement.vue?vue&type=template&id=49a19fac&scoped=true&"
import script from "./authorizationManagement.vue?vue&type=script&lang=ts&"
export * from "./authorizationManagement.vue?vue&type=script&lang=ts&"
import style0 from "./authorizationManagement.vue?vue&type=style&index=0&id=49a19fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a19fac",
  null
  
)

export default component.exports